import React, {useState, useEffect} from "react";
import { Box, Typography, TextField, Divider, Grid, FormControlLabel, Checkbox, MenuItem, Tabs, Tab, Button, IconButton,Table, TableHead, TableBody, TableRow, TableCell, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { useOutletContext, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLogger } from "../../hooks/useLogger";
import Loader from "../../components/Loader";
import AllEndpointsTable from "../../components/AllEnpoints/allEndpointsTable";
import Cookies from "js-cookie";
import { developerTollApi } from "../../services/developerTollApi";
import AddEndpoint from "../../components/AllEnpoints/addEndpoint";

const AllEndpoints = () => {
    const logEvent = useLogger();
    const { open } = useOutletContext();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const token = Cookies.get("_d_token");
    const [loader, setLoader] = useState(false);
    const [allProducts, setAllProducts] = useState([]);
    const [allTags, setAllTags] = useState([]);
    const [allEndpoints, setAllEndpoints] = useState([]);
    const [openEditor, setOpenEditor] = useState(false);
    const [editEndpoint, setEditEndpoint] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedTag, setSelectedTag] = useState(null);
    const [selectedEndpoint, setSelectedEndpoint] = useState(null);
    
    useEffect(() => {
        if (allProducts.length > 0 && !selectedProduct) {
            setSelectedProduct(allProducts[0].product_id);
        }
    }, [allProducts, selectedProduct]);

    useEffect(() => {
        if (allTags.length > 0) {
            setSelectedTag(allTags[0].tag_id);
        }
    }, [allTags]);

    const fetchAllProducts = async () => {
        setLoader(true);
        try {
            const response = await developerTollApi.getAllProducts();
            console.log(response)
            if(response?.status)
            {
                setAllProducts(response?.data)
            }
        } catch (error) {
            console.error("Error fetching line chart data:", error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        if(token) fetchAllProducts();
    }, [token]);

    useEffect(() => {
        if (selectedProduct) {           
            fetchAllTags();
        }
    }, [selectedProduct]);

    const fetchAllTags = async () => {
        console.log(selectedProduct)
        if(selectedProduct)
        {
            setLoader(true);
            try {
                const response = await developerTollApi.getAllTags(selectedProduct);
                console.log(response)
                if(response?.status)
                {
                    setAllTags(response?.data);
                }
            } catch (error) {
                console.error("Error fetching line chart data:", error);
            } finally {
                setLoader(false);
            }
        }
    };
    
    useEffect(() => {
        if (selectedTag) {           
            fetchAllTagEndpoint();
        }
    }, [selectedTag]);

    const fetchAllTagEndpoint = async () => {
        console.log(selectedTag)
        if(selectedTag)
        {
            setLoader(true);
            try {
                const response = await developerTollApi.getAllTagEndpoint(selectedTag);
                console.log(response)
                if(response?.status)
                {
                    setAllEndpoints(response?.data)
                }
            } catch (error) {
                console.error("Error fetching line chart data:", error);
            } finally {
                setLoader(false);
            }
        }
    };

    return (<>
        {!openEditor && (
            <Box sx={{ flexGrow: 1, p: 3, width: isMobile ? "100%" : open ? "calc(100% - 280px)" : "calc(100% - 100px)", marginLeft: isMobile ? "0" : open ? "280px" : "100px", transition: "margin 0.3s ease", height: "100vh", display: "flex", background: "#f9f9f9", }}>
                <Box mt={10} style={{ borderRadius: "12px", textAlign: "center", background: "#fff", width: "100%", height: "calc(100% - 76px)", marginLeft: open ? "" : "1em", }}>
                    <Box sx={{ display: "flex", alignItems:'center', justifyContent: "space-between", padding: "20px 25px" }}>
                        <Typography noWrap component="p" sx={{ fontSize: '24px', fontWeight: 600, lineHeight: '20px', color: "#1D1D1D", paddingBottom: "2px" }}>
                            All Endpoints
                        </Typography>
                        
                        <Button variant="contained" sx={{ width: '170px', height: 40, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"} }} onClick={() => {setOpenEditor(true); setSelectedEndpoint(null)}} >
                            + Add Endpoint
                        </Button>
                    </Box>
                    <Divider />
                    <Box sx={{ overflow: "auto", height: "calc(100% - 90px)" }}>
                        {allEndpoints && (<AllEndpointsTable allEndpoints={allEndpoints} setSelectedEndpoint={setSelectedEndpoint} selectedEndpoint={selectedEndpoint} setOpenEditor={setOpenEditor} allProducts={allProducts} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} allTags={allTags} setSelectedTag={setSelectedTag} selectedTag={selectedTag} fetchAllTagEndpoint={fetchAllTagEndpoint} setEditEndpoint={setEditEndpoint} />)}
                    </Box>
                </Box>
            </Box>
        )}

        {openEditor && (
            <AddEndpoint openEditor={openEditor} handleClose={() => setOpenEditor(false)} selectedEndpoint={selectedEndpoint} allProducts={allProducts} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} allTags={allTags} setSelectedTag={setSelectedTag} selectedTag={selectedTag} fetchAllTagEndpoint={fetchAllTagEndpoint} editEndpoint={editEndpoint} />
        )}

        {loader && (<Loader />)}
    </>);
};

export default AllEndpoints;
